"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.leadingCharacters = void 0;

var _number = require("../type-checks/number");

var _string = require("../type-checks/string");

var leadingCharacters = function leadingCharacters(input) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$minLength = _ref.minLength,
      minLength = _ref$minLength === void 0 ? 2 : _ref$minLength,
      _ref$leadChar = _ref.leadChar,
      leadChar = _ref$leadChar === void 0 ? "0" : _ref$leadChar;

  if ((0, _string.isString)(input) || (0, _number.isNumber)(input) && (input = input.toString())) {
    while (input.length < minLength) {
      input = leadChar + input;
    }
  }

  return input;
};

exports.leadingCharacters = leadingCharacters;